import { useLocation, useParams } from "react-router";
import { Page } from "../types";
import { getPathnameSegments } from "./utils";

export default function usePage() {
  const { pathname } = useLocation();
  const segments = getPathnameSegments(pathname);
  const { teamSlug, rfqId, partId } = useParams();

  if (!teamSlug) return;

  if (segments.length === 3 && segments[2] === "rfqs") {
    return Page.rfqs;
  } else if (segments.length === 3 && segments[2] === "organizations") {
    return Page.organizations;
  } else if (segments.length === 4 && segments[2] === "settings") {
    return Page.settings;
  } else if (segments.length === 3 && segments[2] === "profile") {
    return Page.profile;
  } else if (rfqId && segments.length === 4) {
    return Page.rfq;
  } else if (rfqId && partId) {
    return Page.part;
  } else if (rfqId && segments[4] === "quote") {
    return Page.quote;
  } else if (rfqId && segments[4] === "send") {
    return Page.send;
  } else if (rfqId && segments[4] === "done") {
    return Page.done;
  }
}
